//Util
import {flatten} from 'util/toc'

export function childSelected(selected: any, children:[]):boolean {
  let childNodes = flatten(children)
  let foundIndex = childNodes.findIndex(child => {
    return child === selected
  })

  return foundIndex !== -1 
}

export function traverseNode ( op: string): void {
  let currFocus = document.activeElement
  let visibleNodes = document.getElementsByClassName('visibleNode')
  let currIndex = Array.prototype.findIndex.call(visibleNodes, function(node){
    return currFocus === node
  });
  if ( op === 'up' && currIndex > 0) {
    let node = visibleNodes[currIndex - 1] as HTMLElement
    node.focus()
  }
  if ( op === 'down' && currIndex < visibleNodes.length - 1) {
    let node = visibleNodes[currIndex + 1] as HTMLElement
    node.focus()
  }
}

export function keyboardClick(): void {
  let focused = document.activeElement 
    let link = focused?.lastElementChild as HTMLElement
    if (link) {
      link.click()
    }
}

export function focusElement(e: React.MouseEvent): void {
  let clicked = e.currentTarget as HTMLElement
  clicked.focus({preventScroll: true})
}

export function focusParent(): void {
  let containerElement = document.activeElement?.closest('ul')
  if (containerElement) {
    let node = containerElement.previousSibling as HTMLElement
    node && node.focus({preventScroll:true})
  }
}

export function scrollIntoView(): void {
  let selectedNode = document.querySelector('#TOC .selectedNode')
    let selected = selectedNode as HTMLElement
    selected && selected.scrollIntoView({
      block: "center"
    })
}
